export enum PolicyPageType {
    View,
    Checkout,
    Modify,
    Cancel,
    EditFlights
}